import { DITypes } from "@/core/@types/types";
import { IToastNotification } from "@/composables/shared/notification/types";
import useNotification from "@/composables/shared/notification/useNotification";
import { IDefaultHorizonsResponse } from "@/services/financas/gateways/types";
import type { HttpClient } from "@/core/services/protocols/types";
import { inject, injectable } from "inversify";
import {
  IGetContatoExistenteResponse,
  IGetContatoParams,
  IGetContatoResponse,
  IPostContatoParams,
  IResponseBase,
  IWhatsAppGateway
} from "./WhatsAppGateway";

@injectable()
export default class WhatsAppHttpGateway implements IWhatsAppGateway {
  @inject(DITypes.INDICADORES_HTTP_CLIENT)
  private httpClient!: HttpClient;

  private notification!: IToastNotification<string>;

  constructor() {
    this.notification = useNotification();
  }

  async getContato(
    params: IGetContatoParams
  ): Promise<IGetContatoResponse | undefined> {
    const data = await this.httpClient.get<IResponseBase<IGetContatoResponse>>({
      url: `/v1/whatsapp/obter-lista-cadastrados-whatsapp?status=${
        params.status || ""
      }&nome=${params.nome}&telefone=${params.telefone}&boletim=${
        params.tipoRelatorios
      }`
    });

    if (data?.statusCode !== 200) {
      return [];
    }

    return data.body?.result;
  }

  async getContatoExistente(): Promise<
    IGetContatoExistenteResponse | undefined
    // eslint-disable-next-line indent
  > {
    const data = await this.httpClient.get<
      IResponseBase<IGetContatoExistenteResponse>
    >({
      url: "/v1/whatsapp/obter-lista-usuarios-whatsapp"
    });

    if (data?.statusCode !== 200) {
      return [];
    }

    return data.body?.result;
  }

  async postContato(params: IPostContatoParams): Promise<void> {
    const response = await this.httpClient.post<
      IDefaultHorizonsResponse<unknown>
    >({
      url: "/v1/whatsapp/salvar-usuario-contato-cadastrado-whatsapp",
      body: { ...params }
    });

    if (response.body?.errors) {
      this.notification.showNotification(
        response.body.errors.map((item) => item.message).join("<br />"),
        {
          type: "error",
          allowHtml: true
        }
      );
    }
  }

  async deleteContato(params: string): Promise<void> {
    await this.httpClient.delete({
      url: "/v1/whatsapp/excluir-contato-cadastrado-whatsapp",
      body: { cadastradoId: params }
    });
  }
}
